<!--begin::Body-->
<div class="kt-login__body">
    <!--begin::Signin-->
    <div class="kt-login__form">
        <kt-auth-notice></kt-auth-notice>

        <div class="card shadow">
            <h4 class="align-middle text-center my-3">Kullanıcı Kayıt</h4>
            <p style="font-size: 12px; color: red !important; text-align: center">
                Nüfüs cüzdanınızda yeralan verilerinizi giriniz
            </p>
            <p style="font-size: 12px; color: red !important; text-align: center">
                Yabancı Uyruklu Mezunlarımız Yu-Numarası Kullanarak Kayıt Olabilirler.
            </p>

            <div class="kt-login__divider" style="margin: 0 !important">
                <div class="kt-divider">
                    <span></span>
                </div>
            </div>
            <form
                id="register-frm"
                [formGroup]="registerForm"
                (ngSubmit)="submit()"
                class="card-body"
                autocomplete="off"
                novalidate
            >
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="identificationNumber">T.C. Kimlik Numarası / YU Numarası</label>
                            <input
                                id="identificationNumber"
                                type="text"
                                class="form-control"
                                placeholder="T.C. Kimlik Numarası / YU Numarası"
                                aria-placeholder="T.C. Kimlik Numarası"
                                formControlName="identificationNumber"
                                [ngClass]="{
                                    'is-invalid': registerForm.touched && registerForm.controls.identificationNumber?.errors,
                                    'is-valid':
                                        registerForm.touched && !registerForm.controls.useridentificationNumberName?.errors
                                }"
                            />
                            <div
                                *ngIf="registerForm.touched && registerForm.controls.identificationNumber?.errors?.required"
                                class="invalid-feedback"
                            >
                                {{ 'VALIDATION.REQUIRED_FIELD' | translate }}
                            </div>
                            <div
                                *ngIf="registerForm.touched && registerForm.controls.identificationNumber?.errors?.minlength"
                                class="invalid-feedback"
                            >
                                {{ 'VALIDATION.MIN_LENGTH_FIELD' | translate }}
                                {{ registerForm.controls.identificationNumber?.errors?.minlength.requiredLength }}
                            </div>
                            <div
                                *ngIf="registerForm.touched && registerForm.controls.identificationNumber?.errors?.maxlength"
                                class="invalid-feedback"
                            >
                                {{ 'VALIDATION.MAX_LENGTH_FIELD' | translate }}
                                {{ registerForm.controls.identificationNumber?.errors?.maxlength.requiredLength }}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="email">E-posta</label>
                            <input
                                id="email"
                                type="text"
                                class="form-control"
                                placeholder="E-Posta"
                                aria-placeholder="E-Posta"
                                formControlName="email"
                                [ngClass]="{
                                    'is-invalid': registerForm.touched && registerForm.controls.email?.errors,
                                    'is-valid': registerForm.touched && !registerForm.controls.email?.errors
                                }"
                            />
                            <div
                                *ngIf="registerForm.touched && registerForm.controls.email?.errors?.required"
                                class="invalid-feedback"
                            >
                                {{ 'VALIDATION.REQUIRED_FIELD' | translate }}
                            </div>
                            <div
                                *ngIf="registerForm.touched && registerForm.controls.email?.errors?.minlength"
                                class="invalid-feedback"
                            >
                                {{ 'VALIDATION.MIN_LENGTH_FIELD' | translate }}
                                {{ registerForm.controls.email?.errors?.minlength.requiredLength }}
                            </div>
                            <div
                                *ngIf="registerForm.touched && registerForm.controls.email?.errors?.maxlength"
                                class="invalid-feedback"
                            >
                                {{ 'VALIDATION.MAX_LENGTH_FIELD' | translate }}
                                {{ registerForm.controls.email?.errors?.maxlength.requiredLength }}
                            </div>
                            <div
                                *ngIf="registerForm.touched && registerForm.controls.email?.errors?.email"
                                class="invalid-feedback"
                            >
                                {{ 'VALIDATION.EMAIL_FIELD' | translate }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="firstName">Adı</label>
                            <input
                                id="firstName"
                                type="text"
                                class="form-control"
                                placeholder="Adı"
                                aria-placeholder="Adı"
                                formControlName="firstName"
                                [ngClass]="{
                                    'is-invalid': registerForm.touched && registerForm.controls.firstName?.errors,
                                    'is-valid': registerForm.touched && !registerForm.controls.firstName?.errors
                                }"
                            />
                            <div
                                *ngIf="registerForm.touched && registerForm.controls.firstName?.errors?.required"
                                class="invalid-feedback"
                            >
                                {{ 'VALIDATION.REQUIRED_FIELD' | translate }}
                            </div>
                            <div
                                *ngIf="registerForm.touched && registerForm.controls.firstName?.errors?.minlength"
                                class="invalid-feedback"
                            >
                                {{ 'VALIDATION.MIN_LENGTH_FIELD' | translate }}
                                {{ registerForm.controls.firstName?.errors?.minlength.requiredLength }}
                            </div>
                            <div
                                *ngIf="registerForm.touched && registerForm.controls.firstName?.errors?.maxlength"
                                class="invalid-feedback"
                            >
                                {{ 'VALIDATION.MAX_LENGTH_FIELD' | translate }}
                                {{ registerForm.controls.firstName?.errors?.maxlength.requiredLength }}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="lastName">Soyadı</label>
                            <input
                                id="lastName"
                                type="text"
                                class="form-control"
                                placeholder="Soyadı"
                                aria-placeholder="Soyadı"
                                formControlName="lastName"
                                [ngClass]="{
                                    'is-invalid': registerForm.touched && registerForm.controls.lastName?.errors,
                                    'is-valid': registerForm.touched && !registerForm.controls.lastName?.errors
                                }"
                            />
                            <div
                                *ngIf="registerForm.touched && registerForm.controls.lastName?.errors?.required"
                                class="invalid-feedback"
                            >
                                {{ 'VALIDATION.REQUIRED_FIELD' | translate }}
                            </div>
                            <div
                                *ngIf="registerForm.touched && registerForm.controls.lastName?.errors?.minlength"
                                class="invalid-feedback"
                            >
                                {{ 'VALIDATION.MIN_LENGTH_FIELD' | translate }}
                                {{ registerForm.controls.lastName?.errors?.minlength.requiredLength }}
                            </div>
                            <div
                                *ngIf="registerForm.touched && registerForm.controls.lastName?.errors?.maxlength"
                                class="invalid-feedback"
                            >
                                {{ 'VALIDATION.MAX_LENGTH_FIELD' | translate }}
                                {{ registerForm.controls.lastName?.errors?.maxlength.requiredLength }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="dateOfBirth">Doğum Tarihi Ör. (22.11.2001)</label>
                            <input
                                id="dateOfBirth"
                                type="date"
                                class="form-control"
                                formControlName="dateOfBirth"
                                [ngClass]="{
                                    'is-invalid': registerForm.touched && registerForm.controls.dateOfBirth?.errors,
                                    'is-valid': registerForm.touched && !registerForm.controls.dateOfBirth?.errors
                                }"
                            />
                            <div
                                *ngIf="registerForm.touched && registerForm.controls.dateOfBirth?.errors?.required"
                                class="invalid-feedback"
                            >
                                {{ 'VALIDATION.REQUIRED_FIELD' | translate }}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="motherName">Anne Adı</label>
                            <input
                                id="motherName"
                                type="text"
                                class="form-control"
                                placeholder="Anne Adı"
                                aria-placeholder="Anne Adı"
                                formControlName="motherName"
                                [ngClass]="{
                                    'is-invalid': registerForm.touched && registerForm.controls.motherName?.errors,
                                    'is-valid': registerForm.touched && !registerForm.controls.motherName?.errors
                                }"
                            />
                            <div
                                *ngIf="registerForm.touched && registerForm.controls.motherName?.errors?.required"
                                class="invalid-feedback"
                            >
                                {{ 'VALIDATION.REQUIRED_FIELD' | translate }}
                            </div>
                            <div
                                *ngIf="registerForm.touched && registerForm.controls.motherName?.errors?.minlength"
                                class="invalid-feedback"
                            >
                                {{ 'VALIDATION.MIN_LENGTH_FIELD' | translate }}
                                {{ registerForm.controls.motherName?.errors?.minlength.requiredLength }}
                            </div>
                            <div
                                *ngIf="registerForm.touched && registerForm.controls.motherName?.errors?.maxlength"
                                class="invalid-feedback"
                            >
                                {{ 'VALIDATION.MAX_LENGTH_FIELD' | translate }}
                                {{ registerForm.controls.motherName?.errors?.maxlength.requiredLength }}
                            </div>
                        </div>
                    </div>
                </div>
                <!-- *ngIf="!registerForm.get('isForeign').value || registerForm.get('isCardRequired').value" -->
                <div class="row" *ngIf="!registerForm.get('isForeign').value">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label for="cardSeriesAndNumber">
                                <span
                                    style="text-decoration: underline"
                                    class="text-info"
                                    placeholder="E-Posta / KimlikNo"
                                    aria-placeholder="E-Posta / Kimlik No"
                                    [ngbPopover]="popBirthCertificate"
                                    triggers="mouseenter:mouseleave"
                                    popoverTitle="Nüfus Cüzdanı Seri/No Örnek"
                                    >Nüfus Cüzdanı</span
                                >
                                ya da
                                <span
                                    style="text-decoration: underline"
                                    class="text-info"
                                    [ngbPopover]="popIdentityCard"
                                    triggers="mouseenter:mouseleave"
                                    popoverTitle="Kimlik Kartı Seri No Örnek"
                                    >Kimlik Kartı</span
                                >
                                Seri No Ör. (A2233U444)
                                <p>Sadece Yabancı Uyruklu Mezunlar İçin Zorunludur.</p></label
                            >
                            <ng-template #popBirthCertificate>
                                <img class="img-fluid" src="./assets/media/help/bc.png" alt="Nüfus Cüzdanı" />
                            </ng-template>
                            <ng-template #popIdentityCard>
                                <img class="img-fluid" src="./assets/media/help/ic.png" alt="Nüfus Cüzdanı" />
                            </ng-template>
                            <input
                                id="cardSeriesAndNumber"
                                type="text"
                                class="form-control"
                                placeholder="Nüfus Cüzdanı ya da Kimlik Kartı Seri No Ör. (A2233U444)"
                                aria-placeholder="Nüfus Cüzdanı ya da Kimlik Kartı Seri No Ör. (A2233U444)"
                                formControlName="cardSeriesAndNumber"
                                [ngClass]="{
                                    'is-invalid': registerForm.touched && registerForm.controls.cardSeriesAndNumber?.errors,
                                    'is-valid': registerForm.touched && !registerForm.controls.cardSeriesAndNumber?.errors
                                }"
                            />
                            <div
                                *ngIf="registerForm.touched && registerForm.controls.cardSeriesAndNumber?.errors?.required"
                                class="invalid-feedback"
                            >
                                {{ 'VALIDATION.REQUIRED_FIELD' | translate }}
                            </div>
                            <div
                                *ngIf="registerForm.touched && registerForm.controls.cardSeriesAndNumber?.errors?.minlength"
                                class="invalid-feedback"
                            >
                                {{ 'VALIDATION.MIN_LENGTH_FIELD' | translate }}
                                {{ registerForm.controls.cardSeriesAndNumber?.errors?.minlength.requiredLength }}
                            </div>
                            <div
                                *ngIf="registerForm.touched && registerForm.controls.cardSeriesAndNumber?.errors?.maxlength"
                                class="invalid-feedback"
                            >
                                {{ 'VALIDATION.MAX_LENGTH_FIELD' | translate }}
                                {{ registerForm.controls.cardSeriesAndNumber?.errors?.maxlength.requiredLength }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="password">Parola</label>
                            <input
                                id="password"
                                type="password"
                                class="form-control"
                                placeholder="Parola"
                                aria-placeholder="Parola"
                                formControlName="password"
                                [ngClass]="{
                                    'is-invalid': registerForm.touched && registerForm.controls.password?.errors,
                                    'is-valid': registerForm.touched && !registerForm.controls.password?.errors
                                }"
                            />
                            <div
                                *ngIf="registerForm.touched && registerForm.controls.password?.errors?.required"
                                class="invalid-feedback"
                            >
                                {{ 'VALIDATION.REQUIRED_FIELD' | translate }}
                            </div>
                            <div
                                *ngIf="registerForm.touched && registerForm.controls.password?.errors?.minlength"
                                class="invalid-feedback"
                            >
                                {{ 'VALIDATION.MIN_LENGTH_FIELD' | translate }}
                                {{ registerForm.controls.password?.errors?.minlength.requiredLength }}
                            </div>
                            <div
                                *ngIf="registerForm.touched && registerForm.controls.password?.errors?.maxlength"
                                class="invalid-feedback"
                            >
                                {{ 'VALIDATION.MAX_LENGTH_FIELD' | translate }}
                                {{ registerForm.controls.password?.errors?.maxlength.requiredLength }}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="confirmPassword">Parola Tekrar</label>
                            <input
                                id="confirmPassword"
                                type="password"
                                class="form-control"
                                placeholder="Parola Tekrar"
                                aria-placeholder="Parola Tekrar"
                                formControlName="confirmPassword"
                                [ngClass]="{
                                    'is-invalid': registerForm.touched && registerForm.controls.confirmPassword?.errors,
                                    'is-valid': registerForm.touched && !registerForm.controls.confirmPassword?.errors
                                }"
                            />
                            <div
                                *ngIf="registerForm.touched && registerForm.controls.confirmPassword?.errors?.required"
                                class="invalid-feedback"
                            >
                                {{ 'VALIDATION.REQUIRED_FIELD' | translate }}
                            </div>
                            <div
                                *ngIf="registerForm.touched && registerForm.controls.confirmPassword?.errors?.minlength"
                                class="invalid-feedback"
                            >
                                {{ 'VALIDATION.MIN_LENGTH_FIELD' | translate }}
                                {{ registerForm.controls.confirmPassword?.errors?.minlength.requiredLength }}
                            </div>
                            <div
                                *ngIf="registerForm.touched && registerForm.controls.confirmPassword?.errors?.maxlength"
                                class="invalid-feedback"
                            >
                                {{ 'VALIDATION.MAX_LENGTH_FIELD' | translate }}
                                {{ registerForm.controls.confirmPassword?.errors?.maxlength.requiredLength }}
                            </div>
                            <div
                                *ngIf="registerForm.touched && registerForm.controls.confirmPassword?.errors?.confirmPassword"
                                class="invalid-feedback"
                            >
                                {{ 'VALIDATION.MATCH_PASSWORD_FIELD' | translate }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text-right">
                    <a class="btn btn-default mr-2" routerLink="/auth/login" type="button"
                        ><i class="fa fa-chevron-left"></i> Geri Dön</a
                    >
                    <button class="btn btn-primary" type="submit" [disabled]="isButtonDisabled">
                        <span *ngIf="isButtonDisabled">Bekleyiniz...</span>
                        <i class="fa fa-save"></i> Tamamla
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
